import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  form(e) {
    e.preventDefault()
    const popup = document.querySelector('.popup_product')
    popup.classList.add('popup_product-form')
    document.querySelector('.order-form__text[name="name"]').focus()
  }

  delivery(e) {
    const select = e.currentTarget
    const delivery = document.querySelector('.order-form__delivery')
    
    if (select.value === "true") {
      delivery.classList.add('order-form__delivery_hidden')
    } else {
      delivery.classList.remove('order-form__delivery_hidden')
    }    
  }

  submit(e) {
    e.preventDefault()
    const popup = document.querySelector('.popup_product')
    const form = e.currentTarget
    const formData = new FormData(form)
    const phone = form.querySelector('input[name="phone"]')
    const phoneError = form.querySelector('.order-form__error-phone')
    const formError = form.querySelector('.order-form__error-form')

    // clear errors
    popup.querySelectorAll('.order-form__error_show').forEach(el => {
      el.classList.remove('order-form__error_show')
    })

    if (phone.value.length !== 18) {
      phoneError.classList.add('order-form__error_show')
      return
    }

    if (form.classList.contains('order-form_saving')) {
      return
    } else {
      form.classList.add('order-form_saving')
    }

    formData.append('shop_domain', window.location.host.split('.')[0])
    
    fetch('/new_order', { method: 'POST', body: formData })
    .then(response => {
      if (response.ok) {
        response.json().then(parsed => {
          if (parsed.status === 'success') {
            if (parsed.payment_url) {
              window.location.href = parsed.payment_url
              return
            }
            popup.querySelector('.success__title span').innerHTML = parsed.order_id
            popup.classList.add('popup_product-success')
          } else {
            formError.classList.add('order-form__error_show')
          }
        })
      } else {
        formError.classList.add('order-form__error_show')
      }

      form.classList.remove('order-form_saving')
    })    
  }

}
